import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LanguageTranslateService } from '../_services/language-translate.service';

@Injectable()
export class ErrorUtil {
    protected subscriptions: any[] = [];
    subjectOpenMessageModal : Subject<any> = new Subject();
    subjectOpenMessageModal$ = this.subjectOpenMessageModal.asObservable();

    subjectOpenToastModal : Subject<any> = new Subject();
    subjectOpenToastModal$ = this.subjectOpenToastModal.asObservable();
    constructor(private router: Router, private languageTranslateService: LanguageTranslateService ) { }

    openMessageModal(showWelcomeModal :any, type :any, localeHeader:any, localeMsg:any, messageElement:any,life:any) {
        let modalObj = {
            "showWelcomeModal": showWelcomeModal,
            "severity": type,
            "summary": localeHeader,
            "detail": localeMsg,
            "messageElement":messageElement,
            "life":life,
            "escape":false
        }
        console.log(modalObj)
        if(messageElement == 'message'){
            this.subjectOpenMessageModal.next(modalObj);
        }else{
            this.subjectOpenToastModal.next(modalObj);
        }
       
    }
    setErrorMessage(errorCode:any, body:any = null, message:any = null, errorType:any = 'error',life:any = 300000 ) {
        //  body = JSON.parse(body);
        //console.log(errorCode, body)
         console.log(errorCode)

        // Normalize accidental object status (e.g. full HttpErrorResponse)
        if (errorCode && typeof errorCode === 'object') {
            errorCode = errorCode.status ?? errorCode.errorCode ?? errorCode;
        }

        // Session expired / unauthorized — interceptor already redirects to login
        if (errorCode == 401) {
            return;
        }

        if (errorCode == 0) {
            this.openMessageModal(true, errorType , message, body,"message",life)
        }else if (errorCode == 200 || errorCode == 201) {
                this.openMessageModal(true, errorType , message, body,"toster",life)
        }else if (errorCode == 404 || errorCode == 400) {
            this.openMessageModal(true, errorType , "Error",message,"toster",life)
        } else {
            this.openMessageModal(true, "error", "Error Code "+ errorCode, "Oops.... Something went wrong, please try again.","toster",life)
        }
        //TODO : create a generic and custom error msg per error code
    }

    processErrorTitle(error: any, translate: any): string {
        let errorTitle = error.title
        if (error.type === 'dynamic-lang-error') {
          const data = `${error.instance}.validationBE.${error.detail}`;
          const message =  this.languageTranslateService.getNestedValue(translate, data);
          if (message) {
            errorTitle = message;
          }
        }
        return errorTitle;
      }

   
    
}